import { render, staticRenderFns } from "./ProRiskAnalysisChart.vue?vue&type=template&id=0f82c0bc&scoped=true&"
import script from "./ProRiskAnalysisChart.vue?vue&type=script&lang=js&"
export * from "./ProRiskAnalysisChart.vue?vue&type=script&lang=js&"
import style0 from "./ProRiskAnalysisChart.vue?vue&type=style&index=0&id=0f82c0bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f82c0bc",
  null
  
)

export default component.exports